import {
  ChangeDetectorRef,
  Component,
  HostListener,
  OnInit,
  ViewChild,
} from "@angular/core";

import { Router } from "@angular/router";
import { AuthService } from "./services/auth.service";
import { TutorialService } from "./services/tutorial.service";
declare var $;

@Component({
  selector: "ngx-app",
  templateUrl: "./app.component.html",
  styleUrls: ["app.component.scss"],
})
export class AppComponent implements OnInit {
  pagesComponent = false;

  constructor(
    private router: Router,
    private authService: AuthService,
    private cdr: ChangeDetectorRef,
    private tutorialService: TutorialService
  ) {}

  async ngOnInit() {
    this.authService.handleAuthCallback();
    this.setTutorial();
  }

  setTutorial() {
    setTimeout(() => {
      this.tutorialService.setTour({
        tourId: "test",
        steps: [
          {
            title: "Welcome to Gitten",
            content:
              "One of the best git-based management platform, without all the hassle of git and technical stuff",
            selector: "nav",
            orientation: "bottom",
          },
          {
            title: "Your Repositories",
            content: "Here you can see all your repositories and their files",
            selector: "ngx-repo-tree-sidebar",
            orientation: "right",
          },
          {
            title: "Your Branches",
            content:
              "Once you select a repository, you can see all the branches in that repository",
            selector: "ngx-repo-tree-sidebar",
            orientation: "right",
          },
          {
            title: "Visualize your files",
            content:
              "Gitten allows you to visualize your files in a simple and easy way: just click on a file and you will see its content",
            selector: "ngx-repo-tree-sidebar",
            orientation: "right",
          },
          {
            title: "Visualization modes",
            content:
              "If your repo contains documentation, Gitten will automatically switch to Doc mode, showing only the markdown files. You can switch to Code mode to see all the files in the repository",
            orientation: "right",
            selector: "ngx-repo-tree-sidebar .row",
          },
          {
            title: "Management files",
            content:
              "You can manage your files by creating new files, editing existing ones, or deleting them",
            selector: "ngx-markdown-editor",
            orientation: "center",

          },
          {
            title: "Editing files",
            content:
              "You can edit files in the editor, and save them with the save button. It will automatically commit the changes to the repository.",
            selector: "ngx-markdown-editor [nbpopovertrigger]",
            orientation: "bottom",
          },
          {
            title: "Other magic features",
            content:
              "Gitten has a lot of other features such as auto-save, pull requests, find-in-all-files, and AI suggestions. You can find them in the top bar",
            selector: ".sidebar",
            orientation: "left",
          },
        ],
      });
    }, 2000);
  }

  ngAfterViewInit() {
    document.getElementById("nb-global-spinner").style.display = "none";
  }
}
